import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import variableStyles from '../../styles/variables.module.css.js';

const Variant7PathwayIllustration = /*#__PURE__*/ forwardRef(({ color = variableStyles.black, width = '100%' }, ref)=>jsx("svg", {
        width: width,
        viewBox: "0 0 951 693",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: jsx("path", {
            ref: ref,
            d: "M70.5708 186.022C87.5028 232.574 123.199 272.157 166.355 296.058C209.422 319.96 270.181 332.781 314.767 306.602C339.562 292.037 358.37 268.672 371.058 242.85C381.602 221.405 388.169 198.263 396.032 175.702C407.558 142.598 423.105 111.95 452.949 91.9804C479.039 74.5123 511.875 66.7387 542.925 72.4572C596.759 82.3752 637.012 129.642 641.747 183.431C648.493 259.469 596.089 312.543 548.018 363.384C523.714 389.073 503.476 417.352 497.49 452.869C491.369 489.101 498.92 527.79 519.649 558.303C558.07 614.863 631.427 629.605 695.313 620.581C761.076 611.289 816.696 574.61 880.225 560.09",
            stroke: color,
            strokeWidth: "140",
            strokeMiterlimit: "10",
            strokeLinecap: "round"
        })
    }));

export { Variant7PathwayIllustration as default };
